import React from "react";
import { useState } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

const AccordionItem = (props) => {
  const [selected, setSelected] = useState(false);

  return (
    <div className="item">
      <div
        className={selected ? "title_show" : "title"}
        onClick={() => setSelected(!selected)}
      >
        <p>{props.title}</p>
        {selected ? <IoChevronUp size="2rem" /> : <IoChevronDown size="2rem" />}
      </div>
      <div className={selected ? "content_show" : "content"}>
        {props.children}
      </div>
    </div>
  );
};

export default AccordionItem;
